<div
  class="swipe-area swiper-container"
  #swipeArea>
  <div
    class="swipe-content-container swiper-wrapper"
    #swipeContentContainer>
    <ng-content></ng-content>
  </div>
</div>
